<template>
  <div class="transmission-source-content">
    <top-tabs
      :fileType="fileType"
      @changeType="changeType"
      @doTransmission="(list, fileSource) => doTransmission(list, fileSource)"
    >
    </top-tabs>
    <bottom-tabs
      :fileType="fileType"
      :canTransmission="canTransmission"
      :bottomUplod="bottomUplod"
      @downloadProgram="downloadProgram"
      @downloadFile="downloadFile"
      @downloadInternal="downloadInternal"
    >
    </bottom-tabs>
  </div>
</template>

<script>
import TopTabs from './components/TopTabs/TopTabs.vue'
import BottomTabs from './components/BottomTabs/BottomTabs.vue'
import dayjs from 'dayjs'
import {
  TransferDirectoryFileServiceProxy,
  DncApiServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'
import { getUserInfo } from '@/utils/auth'
import { TenantSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const tssp = new TenantSettingServiceProxy()
const dasp = new DncApiServiceProxy()
const tdfsp = new TransferDirectoryFileServiceProxy()

export default {
  components: {
    TopTabs,
    BottomTabs
  },
  data() {
    return {
      fileType: 'file',
      targetList: [],
      fileSource: '',
      canTransmission: true,
      selectInfo: {},
      bottomUplod: 0,
      timer: null,
      stationList: [] // 后缀集
    }
  },
  created() {
    this.stationList = []
    const user = getUserInfo()
    const tenantId = user.tenant_id
    tssp.getTenantSetting('dncSetting', 'dncSetting', tenantId).then((res) => {
      if (res.paramValue) {
        const key = res.paramValue.split(',')
        this.stationList = key
      }
    })
  },
  methods: {
    downloadProgram(value) {
      console.log(value)
      if ((value.id && value.id == '0') || !value.id) {
        this.$message.warning(this.$t('page_dnc_source_select_transport'))
        return
      }
      if (!this.targetList.length) {
        this.$message.warning(this.$t('page_dnc_source_select_file'))
        return
      }
      let target = undefined
      if (this.stationList.indexOf('null') != -1) {
        target = this.targetList.find((res) => res.name.indexOf('.') === -1)
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this
      if (target) {
        this.$confirm({
          title: this.$t('page_dnc_source_confirm_upload'),
          content: this.$t('page_dnc_source_without_suffix_in'),
          okText: this.$t('page_dnc_source_upload'),
          cancelText: this.$t('page_dnc_source_dnot_upload'),
          onCancel() {
            const list = that.targetList.filter((res) => res.name.indexOf('.') != -1)
            const values = that.addType(list, value.id, 1)
            tdfsp.save(values).then(() => {
              that.$message.success(this.$t('page_dnc_source_upload_success'))
              that.bottomUplod += 1
            })
          },
          onOk() {
            const values = that.addType(that.targetList, value.id, 1)
            tdfsp.save(values).then(() => {
              that.$message.success(this.$t('page_dnc_source_upload_success'))
              that.bottomUplod += 1
            })
          }
        })
      } else {
        const values = that.addType(that.targetList, value.id, 1)
        tdfsp.save(values).then(() => {
          that.$message.success(this.$t('page_dnc_source_upload_success'))
          that.bottomUplod += 1
        })
      }
    },
    downloadFile(value) {
      if ((value.id && value.id == '0') || !value.id) {
        this.$message.warning(this.$t('page_dnc_source_select_transport'))
        return
      }
      if (!this.targetList.length) {
        this.$message.warning(this.$t('page_dnc_source_select_file'))
        return
      }
      const values = this.addType(this.targetList, value.id, 2)
      tdfsp.save(values).then(() => {
        this.$message.success(this.$t('page_dnc_source_upload_success'))
        this.bottomUplod += 1
      })
    },
    downloadInternal(value) {
      if (!value.internalStorage) {
        this.$message.warning(this.$t('page_dnc_source_has_not_opened'))
        return
      }
      if (!value.gateWayCode || !value.appCode) {
        this.$message.warning(this.$t('page_dnc_source_select_transport'))
        return
      }
      if (!this.targetList.length) {
        this.$message.warning(this.$t('page_dnc_source_select_file'))
        return
      }
      let target = undefined
      if (this.stationList.indexOf('null') != -1) {
        target = this.targetList.find((res) => res.name.indexOf('.') === -1)
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this
      if (target) {
        this.$confirm({
          title: this.$t('page_dnc_source_confirm_upload'),
          content: this.$t('page_dnc_source_without_suffix_in'),
          okText: this.$t('page_dnc_source_upload'),
          cancelText: this.$t('page_dnc_source_dnot_upload'),
          onOk() {
            that.addContent(that.targetList, value)
          },
          onCancel() {
            const list = that.targetList.filter((res) => res.name.indexOf('.') != -1)
            that.addContent(list, value)
          }
        })
      } else {
        that.addContent(that.targetList, value)
      }
    },
    addContent(targetList, value) {
      targetList.map((res) => {
        const aa = {
          fileName: res.name,
          objectKey: res.objectKey,
          gateWayCode: value.gateWayCode,
          appCode: value.appCode
        }
        dasp.uploadCncFile(aa).then(() => {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.$message.success(this.$t('page_dnc_source_upload_success'))
            this.bottomUplod += 1
          }, 100)
        })
      })
    },
    addType(value, id, type) {
      const node = value.map((res) => {
        const aa = {
          contentLength: res.contentLength,
          contentMd5: res.contentMd5,
          contentType: res.contentType,
          fileSource: this.fileSource,
          fileType: Number(type),
          filename: res.name,
          lastModified: dayjs().valueOf(),
          objectKey: res.objectKey,
          originalFilename: res.name,
          suffix: res.suffix,
          transferDirectoryId: id
        }
        return aa
      })
      return node
    },
    changeType(value) {
      this.fileType = value
    },
    doTransmission(targetList, fileSource) {
      console.log(this.stationList, targetList)
      if (this.stationList && this.stationList.length > 0) {
        let target = undefined
        let staTarget = undefined
        let noStationList = []
        if (this.stationList.indexOf('null') != -1) {
          target = targetList.find((res) => res.name.indexOf('.') === -1)
        }
        if (target) {
          noStationList = targetList.filter((res) => res.name.indexOf('.') != -1)
        } else {
          noStationList = targetList
        }
        staTarget = noStationList.find((res) => {
          const name = res.name.substring(res.name.indexOf('.'))
          return this.stationList.indexOf(name.toUpperCase()) === -1
        })
        if (staTarget) {
          this.canTransmission = false
        } else {
          this.canTransmission = true
        }
      } else {
        this.canTransmission = false
      }
      this.targetList = targetList
      this.fileSource = fileSource
    }
  }
}
</script>

<style lang="less" scoped>
.transmission-source-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;
  justify-content: space-between;
  align-items: flex-start;
}
</style>
